import BigNumber from 'bignumber.js'
import React from 'react'
import { useIndexPrice } from '../../../hooks/trade/indexprice'
import { useInfo24H } from '../../../hooks/trade/info24H'
import { useTradeStore } from '../../../hooks/trade/tradeStore'
import DefaultKrw from './DefaultKrw'

const PricePrevDay = () => {
	const { data: tradeStore, symbol } = useTradeStore()
	const { getPrice } = useIndexPrice(tradeStore?.pairs)
	const { data: info24 } = useInfo24H(symbol)

	const currentprice = BigNumber(
		getPrice(tradeStore?.symbol) || info24?.open || 0
	)
	const rate = BigNumber(currentprice)
		.minus(info24?.prev || 0)
		.multipliedBy(100)
		.dividedBy(currentprice)

	return (
		<DefaultKrw
			title={'등락률'}
			price={rate.toNumber()}
			dp={2}
			krw={false}
			color={true}
			center={true}
			percent={true}
			updown={BigNumber.ROUND_HALF_FLOOR}
		/>
	)
}

export default React.memo(PricePrevDay)
